import { Hero } from "@/components/home/Hero";
import { CreatorsStrip } from "@/components/home/CreatorsStrip";
import { StudioMosaic } from "@/components/home/StudioMosaic";
import { Plaques, ChartTeaser, Memberships } from "@/components/home/Roadmap";

export default function Home() {
  return (
    <div className="space-y-14 sm:space-y-20">
      <div className="animate-rise"><Hero /></div>
      <div className="animate-rise [animation-delay:120ms]"><CreatorsStrip /></div>
      <div className="animate-rise [animation-delay:160ms]"><StudioMosaic /></div>
      <div className="animate-rise [animation-delay:200ms]"><ChartTeaser /></div>
      <div className="animate-rise [animation-delay:280ms]"><Plaques /></div>
      <div className="animate-rise [animation-delay:360ms]"><Memberships /></div>
      <footer className="border-t border-white/10 pt-6 text-xs text-slate-500">
        © {new Date().getFullYear()} NEW WAVE · A showcase for finished AI-created music & video.
      </footer>
    </div>
  );
}
